/**
 * TanStack Query hooks for `customizable-alert-notification-template`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	customizableAlertNotificationTemplateQueryKeys,
	type CreateCustomizableAlertNotificationTemplateBody,
	type ListCustomizableAlertNotificationTemplateResponse,
	type CustomizableAlertNotificationTemplateRow,
} from "./api";

export function useCustomizableAlertNotificationTemplateList(): UseQueryResult<ListCustomizableAlertNotificationTemplateResponse, Error> {
	return useQuery({
		queryKey: customizableAlertNotificationTemplateQueryKeys.list(),
		queryFn: list,
	});
}

export function useCustomizableAlertNotificationTemplateCreate(): UseMutationResult<CustomizableAlertNotificationTemplateRow, Error, CreateCustomizableAlertNotificationTemplateBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: customizableAlertNotificationTemplateQueryKeys.all });
		},
	});
}

export function useCustomizableAlertNotificationTemplateDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: customizableAlertNotificationTemplateQueryKeys.all });
		},
	});
}
